export const environment = {
  production: true,
  serverUrl: '/easytravel/rest/'
};
